import * as React from 'react'
import { default as Button } from '@mulesoft/anypoint-components/lib/Button';
import { BuiltinSvg } from '../BuiltInDashboard/svgs/BuiltinSvg'
import './AnalyticsLandingPage.css'

const goToBuiltIn = () => {
  window.location.href = '#/builtin'
}

export const AnalyticsLandingPage = () => {
    return (
      <div className={'landing-page-container'}>
        <div className={'landing-page-header-analytics'}>
          <span className={'landing-page-subtitle-analytics'}>
              This analytics page has been deprecated.
          </span>
          <div className={'landing-page-delimiter-analytics'}>&nbsp;</div>
          <span className={'landing-page-title-analytics'}>Start using the new API dashboards in Anypoint Monitoring.</span>
          <Button
            className={'landing-button-analytics'}
            kind={'primary'}
            testId={'view-resource-btn'}
            onClick={goToBuiltIn}
          >Go to Anypoint Monitoring
          </Button>
        </div>
        <div className={'landing-image'}>
          <BuiltinSvg/>
        </div>
      </div>
    )
}
